import { render } from "./SocioeconomicStudyPanel.vue?vue&type=template&id=f7bdbb40&scoped=true"
import script from "./SocioeconomicStudyPanel.vue?vue&type=script&lang=js"
export * from "./SocioeconomicStudyPanel.vue?vue&type=script&lang=js"

import "./SocioeconomicStudyPanel.vue?vue&type=style&index=0&id=f7bdbb40&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/matrix_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bdbb40"]])

export default __exports__